export enum SearchRoutingEnum {
  Jobs = 'jobs',
  Companies = 'companies',
}

export enum SearchCompaniesRoutingFragmentEnum {
  Search = '',
  News = 'news',
}
